import PropTypes from 'prop-types';
import TimeRangePicker from 'client/js/util/time_range_picker';

const AccessLogFilters = ({ filters, onFilterChange, filterErrors }) => {
  return (
    <>
      <div className="filter-group">
        <label htmlFor="hostname-filter">Hostname:</label>
        <input
          id="hostname-filter"
          type="text"
          className={`form-control form-control-sm ${filterErrors.hostname ? 'is-invalid' : ''}`}
          value={filters.hostname}
          onChange={(e) => onFilterChange('hostname', e.target.value)}
          placeholder="z.B. example.com"
        />
        {filterErrors.hostname && <div className="invalid-feedback">{filterErrors.hostname}</div>}
      </div>

      <div className="filter-group">
        <label htmlFor="ip-filter">IP-Adresse:</label>
        <input
          id="ip-filter"
          type="text"
          className={`form-control form-control-sm ${filterErrors.ip ? 'is-invalid' : ''}`}
          value={filters.ip}
          onChange={(e) => onFilterChange('ip', e.target.value)}
          placeholder="z.B. 192.168.1.1"
        />
        {filterErrors.ip && <div className="invalid-feedback">{filterErrors.ip}</div>}
      </div>

      <div className="filter-group">
        <label htmlFor="request-path-filter">Request-Pfad:</label>
        <input
          id="request-path-filter"
          type="text"
          className={`form-control form-control-sm ${filterErrors.request_path ? 'is-invalid' : ''}`}
          value={filters.request_path}
          onChange={(e) => onFilterChange('request_path', e.target.value)}
          placeholder="z.B. /api/endpoint"
        />
        {filterErrors.request_path && <div className="invalid-feedback">{filterErrors.request_path}</div>}
      </div>

      <div className="filter-group">
        <label htmlFor="status-filter">Status:</label>
        <input
          id="status-filter"
          type="text"
          className={`form-control form-control-sm ${filterErrors.status ? 'is-invalid' : ''}`}
          value={filters.status}
          onChange={(e) => onFilterChange('status', e.target.value)}
          placeholder="z.B. 200, 404, 500"
        />
        {filterErrors.status && <div className="invalid-feedback">{filterErrors.status}</div>}
      </div>

      <div className="filter-group">
        <label>Zeit:</label>
        <TimeRangePicker
          value={filters.from_time}
          onChange={(timeRange) => {
            if (timeRange) {
              onFilterChange('from_time', timeRange.from_time);
              onFilterChange('to_time', timeRange.to_time);
            } else {
              onFilterChange('from_time', '');
              onFilterChange('to_time', '');
            }
          }}
          error={filterErrors.from_time}
        />
      </div>
    </>
  );
};

AccessLogFilters.propTypes = {
  filters: PropTypes.shape({
    hostname: PropTypes.string,
    ip: PropTypes.string,
    request_path: PropTypes.string,
    status: PropTypes.string,
    from_time: PropTypes.string,
    to_time: PropTypes.string
  }).isRequired,
  onFilterChange: PropTypes.func.isRequired,
  filterErrors: PropTypes.object.isRequired
};

export default AccessLogFilters;
